export enum SignalType {
  LockDown = 0,
  Unlock = 1,
  StartSession = 2,
  EndSession = 3,
  Connected = 4,
  Disconnected = 5,
  SignalReceived = 6,
  Error = 7,
  RemoveEvent = 8,
  UpdateEvent = 9,
  Unknown = 10,
  Ping = 11,
  Pong = 12,
  Transaction = 13,
  Reconnected = 14,
  Rollback = 15,
}
export enum CommandStatus {
  Created = 0,
  Sent = 1,
  Received = 2,
  Applied = 3,
  Failed = 4,
  TimedOut = 5,
  Expired = 6,
  LauncherOffline = 7,
}
export enum CommandDirection {
  ToLauncher = 0,
  ToAdmin = 1,
}
export enum EventChangeType {
  Created = 0,
  Updated = 1,
  Rollback = 2,
  Removed = 3,
}
export enum AssistanceType {
  Help = 0,
}
